import { AbstractEntityMapper } from '@pf/shared-services';
import {
    InventoryBundleCreate,
    InventoryBundleDto,
    InventoryBundleRead,
    InventoryBundleSearchParams,
} from '../../entities/inventory-bundle.dto';
import { Injectable } from '@angular/core';
import { PlatformWmsMapper } from '../platform-wms.mapper';
import { InventoryBundleMetadataMap } from './inventory-bundle.mapping-profile';

@Injectable()
export class InventoryBundleMapper extends AbstractEntityMapper<
    InventoryBundleRead,
    InventoryBundleCreate,
    InventoryBundleDto,
    InventoryBundleSearchParams
> {
    constructor() {
        super(
            InventoryBundleDto,
            PlatformWmsMapper,
            InventoryBundleMetadataMap.symbols
        );
    }
}
